module.exports = __webpack_public_path__ + "img/navbar-1.ea51a21d.png";